import React, {useEffect, useState} from 'react';
import FormCampoTXT from "../../../pageComponents/form/FormCampoTXT";
import FormCampoTAREA from "../../../pageComponents/form/FormCampoTAREA";
import FormCampoCBX from "../../../pageComponents/form/FormCampoCBX";


const isMobile = window.innerWidth < 720;

const FormEse = ({modelNew,listaTipo, onChange, submit}) => {
  
  const [model, setModel] = useState({})
  const [idTipo, setIdTipo] = useState("");
  const [listaPuesto, setListaPuesto] = useState([])
  
  
  
  const updateDic = (campo, valor) => {
    const m = {...model};
    m[campo] = valor;
    onChange(m)
  }
  
  useEffect(() => {
    setModel({...modelNew})
  }, [modelNew]);
  
  useEffect(() => {
    updateDic("id_tipo_ese_string", idTipo)
    const tipoSel = listaTipo.find(k => k.id_tipo_ese.toString() === idTipo.toString());
    setListaPuesto(tipoSel?.listaPuestos || []);
  }, [idTipo]);
  
  
  
  const listaKVTipo = listaTipo.map(k => {
    return {key: k.id_tipo_ese.toString(), label: k.tipo}
  })
  
  const listaKVPuesto = listaPuesto.map(s => {
    return {key: s, label: s}
  })
  
  const elemPuesto = listaPuesto.length === 0
    ? (<FormCampoTXT
      label="Puesto"
      isRequerido={true}
      valor={model.puesto || ''}
      setValor={v => updateDic("puesto", v)}/>)
    : (
      <FormCampoCBX
        listaOptionsKV={[{key: "", label: "- Seleccionar -"}, ...listaKVPuesto]}
        label="Puesto"
        isRequerido={true}
        valor={model.puesto || ""}
        setValor={v => updateDic("puesto", v)}
      />
    );
  
  //'id_tipo_ese', 'evaluado', 'puesto', 'email','tel'
  
  return (
    <>
      
      <div className={ "columns " + (isMobile?" isMobile":"")}>
        <div className="column">
          <FormCampoTXT
            label="Nombre del Evaluado"
            isRequerido={true}
            valor={model.evaluado || ''}
            setValor={v => updateDic("evaluado", v)}/>
          
          <FormCampoCBX
            listaOptionsKV={[{key: "", label: "- Seleccionar -"}, ...listaKVTipo]}
            label="Tipo de Estudio"
            isRequerido={true}
            valor={model.id_tipo_ese_string || ""}
            setValor={v => setIdTipo(v)}
          />
          {idTipo ? elemPuesto : null}
        
        </div>
        <div className="column">
          <FormCampoTXT
            label="Email"
            isRequerido={true}
            valor={model.email || ''}
            isEmail={true}
            setValor={v => updateDic("email", v)}/>
          
          
          <FormCampoTXT
            label="Celular"
            isRequerido={true}
            valor={model.tel || ''}
            setValor={v => updateDic("tel", v)}/>
          
          <FormCampoTAREA
            label="Comentario"
            isRequerido={false}
            valor={model.comCliente || ''}
            setValor={v => updateDic("comCliente", v)}/>
          
        </div>
      </div>
      
      
      <div className="m10T has-text-right">
        <button className="button is-primary"
                onClick={submit}
                style={{paddingLeft: "25px", paddingRight: "25px"}}>
          <i className="fa fa-upload m5R"/>
          Guardar
        </button>
      </div>
    
    </>
  );
};

export default FormEse